"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import CookieConsent from "./CookieConsent";
import PiwikPro from "./PiwikPro";
import CustomVisitTracking from "./CustomVisitTracking";
import GoogleOneTapConsentBridge from "./GoogleOneTapConsentBridge";
interface TrackingBaseProps {
  isPiwikEnabled: boolean;
}
export default function TrackingBase(t0) {
  const $ = _c(3);
  const {
    isPiwikEnabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Suspense fallback={null}><CustomVisitTracking /></Suspense>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isPiwikEnabled) {
    t2 = <>{t1}{isPiwikEnabled ? <Suspense fallback={null}><GoogleOneTapConsentBridge /><PiwikPro /></Suspense> : <CookieConsent />}</>;
    $[1] = isPiwikEnabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}